import { AudioData } from "../data/AudioData";
import { FloatArrayAudioData } from "../data/FloatArrayAudioData";
import { AudioBuilderContext } from "./AudioBuilderContext";
import { Component } from "./components/Component";
import { Curve } from "./curves/Curve";
import { ModifiableCurve } from "./curves/ModifiableCurve";
import { Key } from "./Key";

export class Instrument
{
  keys:Key[] = []; 
  velocity:ModifiableCurve = new ModifiableCurve();
  components:Component[] = [];

  async generateKey( key:Key, context:AudioBuilderContext ):Promise<AudioData>
  {
    context.setKey( key );    

    let velocityCurve = this.velocity.getModifiedCurve( context );
    console.log( "KEY LENGTH INSTRUMENT:", velocityCurve.xLength );
    velocityCurve     = key.velocityModifiers.modify( velocityCurve, context );
    console.log( "KEY LENGTH OF ", key, ":", velocityCurve.xLength );

    let pitchCurve    =  key.getPitchCurve( velocityCurve, context );
     
    context.setKeyData( velocityCurve, pitchCurve );
    

    console.log( "Num Components:", this.components.length );
    
    let output = FloatArrayAudioData.cast( context.createAudioData( velocityCurve.xLength ) );

    for ( let i = 0; i < this.components.length; i++ )
    {
      let state =  100 * i / ( this.components.length ) ;
      console.log( state.toFixed( 2 ) + "%" );
      let componentAudioData = await this.components[ i ].generate( context );
      output.add( componentAudioData );
    }

    return output;
    
  }
}